module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/collectif-musical-violons-du-roy.json
// module id = 580
// module chunks = 175772769238085